const CloseIcon = () => {
  return (
    <svg viewBox="0 0 10 10">
      <path
        d="M59.031,57.617l3.293,3.293a1,1,0,0,1-1.414,1.414l-3.293-3.293-3.293,3.293A1,1,0,0,1,52.91,60.91L56.2,57.617,52.91,54.324a1,1,0,0,1,1.414-1.414L57.617,56.2,60.91,52.91a1,1,0,0,1,1.414,1.414Z"
        transform="translate(-52.617 -52.617)"
        fill="#075da9"
      />
    </svg>
  );
};

export default CloseIcon;
